import type React from 'react';
import {
  usePaywallPopoversStore,
  type SetActivePaywallPopover,
} from '../stores/popover-store';

type UseOpenPopoverPaywallReturn = SetActivePaywallPopover;

export function useOpenPopoverPaywall(): UseOpenPopoverPaywallReturn {
  return usePaywallPopoversStore((state) => state.setActivePaywallPopover);
}

type UseClosePopoverPaywallReturn = () => void;

export function useClosePopoverPaywall(): UseClosePopoverPaywallReturn {
  return usePaywallPopoversStore((state) => state.closePaywallPopover);
}

interface UseActivePaywallPopoverReturn {
  activePaywallPopoverContent: React.JSX.Element | null;
  activePaywallPopoverRef: React.RefObject<HTMLElement>;
  open: boolean;
}

export function useActivePaywallPopover(): UseActivePaywallPopoverReturn {
  return usePaywallPopoversStore((state) => ({
    activePaywallPopoverContent: state.activePaywallPopoverContent,
    activePaywallPopoverRef: state.activePaywallPopoverRef,
    open: state.open,
  }));
}
